import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError, timeout} from 'rxjs';
import {CEP} from '../../../../model/city/cep/cepVM';

@Injectable({
  providedIn: 'root',
})
export class ConsultaCepService {
  constructor(private http: HttpClient) {}
  private getExternalHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Skip-Interceptor': 'true',
      }),
    };
  }

  consultaCEP(cep: any): Observable<any> {
    cep = cep ? cep.toString().replace(/\D/g, '') : '';

    if (cep.length !== 8) {
      return throwError(() => new Error('CEP inválido'));
    }

    // 1ª Tentativa: BrasilAPI (Livre de CORS e sem necessidade de proxy)
    const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cep}`;

    return this.http.get<any>(brasilApiUrl, this.getExternalHttpOptions()).pipe(
      timeout(3000),
      map(brasilApiResponse => {
        const viaCepFormat = {
          cep: brasilApiResponse.cep,
          logradouro: brasilApiResponse.street,
          complemento: brasilApiResponse.complement || '',
          bairro: brasilApiResponse.neighborhood,
          localidade: brasilApiResponse.city,
          uf: brasilApiResponse.state,
          ibge: brasilApiResponse.city_ibge,
        };
        return this.converterRespostaParaCep(viaCepFormat);
      }),
      catchError(() => {
        // 2ª Tentativa (Fallback): ViaCEP direto
        const viaCepUrl = `https://viacep.com.br/ws/${cep}/json/`;

        return this.http.get<any>(viaCepUrl, this.getExternalHttpOptions()).pipe(
          timeout(3000),
          map(response => {
            if (response.erro) {
              throw new Error('CEP não encontrado');
            }
            return this.converterRespostaParaCep(response);
          }),
          catchError(() => {
            return throwError(() => new Error('Não foi possível consultar o CEP nas bases de dados.'));
          }),
        );
      }),
    );
  }

  // Mantido para compatibilidade, reaproveitando a mesma estratégia resiliente
  consultaCEPAlternativo(cep: any): Observable<any> {
    return this.consultaCEP(cep);
  }

  private converterRespostaParaCep(cepNaResposta: any): CEP {
    let cepVM = new CEP();
    cepVM.ibge = cepNaResposta.ibge || '';
    cepVM.cep = cepNaResposta.cep;
    cepVM.logradouro = cepNaResposta.logradouro;
    cepVM.complemento = cepNaResposta.complemento;
    cepVM.bairro = cepNaResposta.bairro;
    cepVM.localidade = cepNaResposta.localidade;
    cepVM.uf = cepNaResposta.uf;
    return cepVM;
  }
}
